import Work1 from "../../assets/dplan-page.png";
import Work2 from "../../assets/cocktail-logo.png";
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/github-searcher-image.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "DPLAN",
    description:
      "Web / App to plan events. Create, share, experience and organize events quickly, easily and fun.",
    technologies: [
      "ReactJS",
      "Javascript",
      "NodeJS",
      "MongoDB",
      "ExpressJS",
      "Axios",
      "API Rest",
      "HTML",
      "CSS",
      "Bootstrap",
      "Git / Github",
    ],
    demo: "https://famous-brioche-240d75.netlify.app/",
    category: "fullstack",
  },
  {
    id: 2,
    image: Work4,
    title: "Github Seatcher",
    description: "Discover GitHub users and their projects with ease.",
    technologies: [
      "Typescript",
      "Next JS",
      "React JS",
      "Javascript",
      "Axios",
      "API Rest",
      "HTML",
      "Tailwind CSS",
      "Git / Github",
    ],
    demo: "https://github-searcher-tkdg.vercel.app/",
    category: "frontend",
  },
  {
    id: 3,
    image: Work2,
    title: "Cocktail Forum",
    description:
      "A website for sharing and obtaining cocktail ideas from users around the world!",
    technologies: [
      "Javascript",
      "NodeJS",
      "MongoDB",
      "Handlebars",
      "ExpressJS",
      "Axios",
      "API Rest",
      "HTML",
      "CSS",
      "Bootstrap",
      "Git / Github",
    ],
    demo: "https://colorful-twill-deer.cyclic.app/",
    category: "backend",
  },
  {
    id: 4,
    image: Work3,
    title: "Flight Radar Tracker",
    description:
      "A website that utilizes live flight information from an API to display flights with relevant details on a global map.",
    technologies: [
      "Javascript",
      "API Rest",
      "HTML",
      "CSS",
      "LeafLet map implementation",
    ],
    demo: "https://pmplcode.github.io/FlightRadar-API-LeafLet/",
    category: "frontend",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "fullstack",
  },
  {
    name: "frontend",
  },
  {
    name: "backend",
  },
];
